import { Shield, ShieldCheck, ShieldOff } from "lucide-react";
import { cn } from "@/lib/utils/cn";

type ShieldState = "available" | "used" | "just-consumed";

/**
 * Streak chip per design handoff §5.3:
 * white background, line border, "🔥 {n} dni z rzędu" — emoji literal, not Lucide icon.
 */
export function StreakChip({
  days,
  shield,
  className,
}: {
  days: number;
  shield?: ShieldState;
  className?: string;
}) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={cn(
          "inline-flex items-center gap-1.5 rounded-full px-3 h-7 text-[13px] font-bold leading-none",
          "bg-white text-navy ring-1 ring-line",
          className,
        )}
      >
        <span aria-hidden className="text-[14px]">🔥</span>
        <span className="font-num">{days}</span>
        <span className="font-medium text-slate">dni z rzędu</span>
      </span>
      {shield ? <StreakShield state={shield} /> : null}
    </span>
  );
}

function StreakShield({ state }: { state: ShieldState }) {
  if (state === "just-consumed") {
    return (
      <span
        title="Tarcza zużyta — uratowano passę dzisiaj"
        aria-label="Tarcza zużyta — uratowano passę"
        className="inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium bg-[#DCF1E4] text-forest ring-1 ring-forest/30"
      >
        <ShieldCheck className="h-3.5 w-3.5" />
        zużyta
      </span>
    );
  }
  if (state === "used") {
    return (
      <span
        title="Tarcza zużyta w tym tygodniu — odnowi się w poniedziałek"
        aria-label="Tarcza zużyta"
        className="inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium bg-[#F1F4EF] text-slate ring-1 ring-line"
      >
        <ShieldOff className="h-3.5 w-3.5" />
      </span>
    );
  }
  return (
    <span
      title="Tarcza dostępna — uratuje 1 zerwany dzień w tym tygodniu"
      aria-label="Tarcza dostępna"
      className="inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium bg-[#EAE6FE] text-[#5240B8] ring-1 ring-[#5240B8]/25"
    >
      <Shield className="h-3.5 w-3.5" />
    </span>
  );
}
